import { DateTime as dateTime } from 'luxon'

// Decides Whether we show the fullcalendar booking flow or the multi-step one
export const isDesktopView = () => window.innerWidth > 768

// Time format (12h vs 24h) for booking slots/events lives in ./time_format, so
// the visitor's preference and the account default drive every surface together.

export const getTimeZoneFromFullcalendar = (fullcalendar) => {
  return fullcalendar.getCurrentData().dateEnv.timeZone
}

// Like toLuxonDateTime, but updates the timezone to the one set on the fullcalendar, but keeps the same time
export const toLuxonDateTimeKeepingSameTime = (date, fullcalendar) => {
  return dateTime
    .fromJSDate(date)
    .setZone(getTimeZoneFromFullcalendar(fullcalendar), { keepLocalTime: true })
}

export const localizedLongDate = (luxonDate, locale) => {
  const date = luxonDate.setLocale(locale).toLocaleString(dateTime.DATE_HUGE)
  return date.charAt(0).toUpperCase() + date.substring(1)
}
